// src/components/SignIn.js
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axiosInstance from "../../utils/axios";
import {
    FormControl,
    FormLabel,
    Input,
    Button,
    Stack,
    Link,
    useToast,
} from "@chakra-ui/react";
import { useAuthentication } from "../../wrappers/UseAuthentication";

const SignIn = () => {
    const toast = useToast();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [formIsSubmitting, setFormIsSubmitting] = useState(false);
    const { signIn } = useAuthentication();
    const navigate = useNavigate();

    const handleSignIn = async (e) => {
        e.preventDefault();
        setFormIsSubmitting(true);

        try {
            const response = await axiosInstance.post('/dummy/WP-login', {
                username: email,
                password: password,
            });

            setFormIsSubmitting(false);
            if (response.status === 200) {
                let { huserID } = response.data.data;
                localStorage.setItem("user_id", huserID);
                toast({
                    title: response.data.message,
                    description: response.data.description,
                    status: "success",
                    duration: 3000,
                    isClosable: true,
                });
                signIn();
                navigate("/users");
            } else {
                toast({
                    title: response.data.message,
                    description: response.data.description,
                    status: "error",
                    duration: 3000,
                    isClosable: true,
                });
            }
        } catch (error) {
            setFormIsSubmitting(false);
            let errMsg = error.response?.data?.data?.error || "Technical Error Occurred";
            toast({
                title: "Sign in Failed!",
                description: errMsg,
                status: "error",
                duration: 3000,
                isClosable: true,
            });
        }
    };

    // Call auto sign-in on component mount
    useEffect(() => {
        // Implement your auto sign-in logic here
        // Redirect to home if user is signed in
    }, []);

    return (
        <FormControl
            maxW="400px"
            mx="auto"
            mt={8}
            p="4"
            borderWidth="1px"
            borderRadius="lg"
        >
            <form onSubmit={handleSignIn}>
                <Stack spacing={4}>
                    <FormControl isRequired>
                        <FormLabel>Email</FormLabel>
                        <Input
                            type="email"
                            placeholder="Enter your email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                        />
                    </FormControl>
                    <FormControl isRequired>
                        <FormLabel>Password</FormLabel>
                        <Input
                            type="password"
                            placeholder="Enter your password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                        />
                    </FormControl>
                    <Button
                        type="submit"
                        colorScheme="blue"
                        bg="#00B0B9"
                        isLoading={formIsSubmitting} // Set isLoading to true when submitting the form
                        loadingText="Signing In"
                    >
                        Sign in
                    </Button>
                    <Link
                        color="#D0DF00"
                        textAlign="center"
                        fontSize="sm"
                        fontWeight={"bold"}
                    >
                        Forgot password?
                    </Link>
                </Stack>
            </form>
        </FormControl>
    );
};

export default SignIn;
